// @flow
import {createSelector} from 'reselect';

import type {ApplicationStoreType} from 'constants/flow/flowTypes';

import type {
    OnePhotoReviewType,
    ProductPhotoReviewsType,
} from 'reducers/product/reviewsPhotosList/reviewsPhotoListType';
import type {ProductReviewsType} from 'reducers/product/reviews/reviewsType';

/**
 * Get product reviews
 * @param {ApplicationStoreType} store - Application Store
 * @returns {ProductPhotoReviewsType} - Product Reviews
 */
export const getReviews = (store: ApplicationStoreType): ProductPhotoReviewsType =>
    store.reviewsPhotosList;

/**
 * Get reviews photos
 * @param {ProductReviewsType} photos from store
 * @return {Array<OnePhotoReviewType>} list reviews
 */
export const getReviewsPhoto = createSelector(
    getReviews,
    (photos: ProductPhotoReviewsType): Array<OnePhotoReviewType> => photos.list,
);

/**
 * Get product reviews
 * @param {ApplicationStoreType} store - Application Store
 * @returns {ProductReviewsType} - Product Reviews
 */
export const getProductReviews = (store: ApplicationStoreType): ProductReviewsType =>
    store.productReviews;

/**
 * Does product have reviews
 * @param {ApplicationStoreType} store - Application Store
 * @returns {ProductReviewsType} - true - has, false - doesn't have
 */
export const hasProductReviews = createSelector(
    getProductReviews,
    (productReviews: ProductReviewsType): boolean => productReviews.count !== '0',
);
